import { BamboraModal } from "./bambora/components/BamboraModal";
import { CollectorModal } from "./collector/components/CollectorModal";
import { CollectorCallbackModal } from "./collectorCallback/components/CollectorCallbackModal";
import { InstabankModal } from "./instabank/components/InstabankModal";
import { KlarnaModal } from "./klarna/components/KlarnaModal";
import { PayExModal } from "./payex/components/PayExModal";
import { PayExCallbackModal } from "./payexCallback/components/PayExCallbackModal";
import { SwishModal } from "./swish/components/SwishModal";
import { VippsModal } from "./vipps/components/VippsModal";

const ConnectionModals = () => (
    <>
        <VippsModal />
        <InstabankModal />
        <PayExModal />
        <PayExCallbackModal />
        <CollectorModal />
        <CollectorCallbackModal />
        <SwishModal />
        <KlarnaModal />
        <BamboraModal />
    </>
);

export default ConnectionModals;
